import { Component, OnInit } from '@angular/core';

import { RenderService } from 'src/app/rendering-3d/services/render.service';
import { Scenes } from 'src/app/rendering-3d/models/scenes.enum';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  state: LayoutState = LayoutState.expanded;
  LayoutState = LayoutState;
  Scenes = Scenes;

  constructor(
      private renderService: RenderService
  ) { }

  ngOnInit(): void {
  }

  changeState(state: LayoutState): void {
    this.state = state;
  }

  selectScene(scene: Scenes): void {
    this.changeState(LayoutState.expanded);
    this.renderService.selectScene(scene);
  }
}

enum LayoutState {
  expanded,
  rolled,
  menu
}
